export function formatLastPaid(lp) {
  if (!lp) return "—";
  const [y, m, d] = lp.date.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  const opts = y === new Date().getFullYear() ? { day: "numeric", month: "short" } : { day: "numeric", month: "short", year: "numeric" };
  return `₹${Number(lp.amount || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })} · ${dt.toLocaleDateString("en-GB", opts)}`;
}
